/** @format */

import { Injectable, signal } from '@angular/core';

import { FacetVO } from '@plp/data-access/interfaces';

@Injectable({
  providedIn: 'root',
})
export class ProductListFilterDrawerService {
  private readonly _isOpen = signal(false);
  private readonly _scrollToFilter = signal<FacetVO | null>(null);
  private readonly _refinementSource = signal<string | undefined>(undefined);

  readonly isOpen = this._isOpen.asReadonly();
  readonly scrollToFilter = this._scrollToFilter.asReadonly();
  readonly refinementSource = this._refinementSource.asReadonly();

  open(scrollToFilter: FacetVO | null = null, refinementSource?: string) {
    this._scrollToFilter.set(scrollToFilter);
    this._isOpen.set(true);
    this._refinementSource.set(refinementSource);
  }

  close() {
    this._isOpen.set(false);
    this._scrollToFilter.set(null);
    this._refinementSource.set(undefined);
  }
}
